import { useQuery } from "react-query";
import axios from "axios";
import React from "react";
import { useState } from "react";

const fetchHumanCharacters = (pageNumber) => {
  return axios.get(
    `https://rickandmortyapi.com/api/character/?species=human&page=${pageNumber}`
  );
};

function Card() {


  const [removeClass, setRemoveClass] = useState("hidden");

  const [pageNumber, setPageNumber] = useState(1);


  const { isLoading, data, isError, error } = useQuery(
    ["characters", pageNumber],
    () => fetchHumanCharacters(pageNumber)
  );

  if (isLoading) {
    return <h2>Hold up getting ricks portal gun....</h2>;
  }

  if (isError) {
    return <h2> {error.message} </h2>;
  }

  return (
    <React.Fragment>
      <ul className="flexCard">
        {data.data.results.map((human, index) => {
          return (
            <React.Fragment>
              <div>
                <img
                  src={human.image}
                  alt={human.id}
                  className="api-img"
                  onClick={ () =>  removeClass ? setRemoveClass("") : setRemoveClass("hidden") }
                  
                />
                <li key={index} className="addMargin">
                  <strong>{human.name}</strong>
                </li>
                <div className={removeClass}>
                  <li key={index + 300} className="addMargin">
                    <strong>Status:</strong> {human.status}
                  </li>
                  <li key={index + 100} className="addMargin">
                    <strong>Origin:</strong> {human.origin.name}
                  </li>
                  <li key={index + 200} className="addMargin">
                    <strong>Location:</strong> {human.location.name}
                  </li>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </ul>
      <div className="has-text-centered">
        <button
          onClick={() => setPageNumber((page) => page - 1)}
          disabled={pageNumber === 1}
          className="button  is-large addMargin"
        >
          Previous
        </button>
        <button
          onClick={() => setPageNumber((page) => page + 1)}
          className="button is-success is-large addMargin"
        >
          Next
        </button>
      </div>
    </React.Fragment>
  );
}

export default Card;
